import { createModule } from '../../createModule';
export const createMiscAPI = createModule(({ http }) => {
    return {
        getPrimeBrokers: async () => {
            const res = await http.get('/v2/static/prime_brokers');
            return res;
        },
        getBanks: async () => {
            const res = await http.get('/v2/static/banks');
            return res;
        },
        getCounterparties: async () => {
            const res = await http.get('/v2/static/trade-counterparties');
            return res;
        },
        getCurrencies: async () => {
            const res = await http.get('/v2/static/currencies');
            return res;
        },
        getGuarantors: async () => {
            const res = await http.get('/v2/static/guarantors');
            return res;
        },
        getIssuers: async () => {
            const res = await http.get('/v2/static/issuers');
            return res;
        },
        getIssuerCodes: async () => {
            const res = await http.get('/v2/static/issuer-codes');
            return res;
        },
        getCountries: async () => {
            const res = await http.get('/v2/static/countries');
            return res;
        },
        getStrategies: async () => {
            const res = await http.get('/v2/static/strategies');
            return res;
        },
        getTradeClients: async () => {
            const res = await http.get('/v2/static/trade-clients');
            return res;
        },
        getAllTraders: async () => {
            const res = await http.get('/v2/static/traders/all');
            return res;
        },
        getTradeTags: async () => {
            const res = await http.get('/v2/static/trade-tags');
            return res;
        },
        timeSeries: {
            downloadExcel: async (body) => {
                const res = await http.post(`/v2/time-series/download`, {
                    body: body,
                    responseType: 'arraybuffer',
                });
                return res;
            },
        },
    };
});
